import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes";

export default function App() {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      {routes.map((r) => (
        <Route path={r.route} element={r.component} key={r.key} />
      ))}
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}
